import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Box, Field, Input, VStack } from '@chakra-ui/react';
import { IMPACT_DIRECTION_OPTIONS, ASSUMPTION_SET_DEFINITION_OPTIONS, WARNING_LABELS } from '@/components/AppBar/NetworkPopover/ReportOptionsDialog/constants';
import { Checkbox } from '@/components/ui/checkbox';
import { InformationIcon } from '@/components/util-component/InformationIcon';
import { WarningOptions } from '@/services/networkReport/models/reportOptions';
import { getWarningDescription } from './utils';
import WarningOptionWithInfo from './WarningOptionWithInfo';
import { WarningOptionWithThreshold } from './WarningOptionWithThreshold';
type WarningOptionsProps = {
  options: WarningOptions;
  onChange: (options: WarningOptions) => void;
  causeImpactSignificanceThreshold: string;
  optimalStateHasABadImpactAllNodePairsThreshold: string;
  optimalStateHasABadImpactParentChildrenPairsThreshold: string;
  wchgAndPchgDirectionNotEqualThreshold: string;
  effectHasHigherProbabilityThanCausesThreshold: string;
  pchgRatioTooBigThreshold: string;
  pchgRatioTooSmallThreshold: string;
  isValidThreshold: (value: string) => boolean;
  isValidRatio: (value: string) => boolean;
  onChangeCauseImpactSignificanceThreshold: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeOptimalStateHasABadImpactAllNodePairsThreshold: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeOptimalStateHasABadImpactParentChildrenPairsThreshold: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeWchgAndPchgDirectionNotEqualThreshold: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeEffectHasHigherProbabilityThanCausesThreshold: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangePchgRatioTooBigThreshold: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangePchgRatioTooSmallThreshold: (e: React.ChangeEvent<HTMLInputElement>) => void;
};
const WarningOptionsDialog = t0 => {
  const $ = _c(67);
  const {
    options,
    onChange,
    causeImpactSignificanceThreshold,
    optimalStateHasABadImpactAllNodePairsThreshold,
    optimalStateHasABadImpactParentChildrenPairsThreshold,
    wchgAndPchgDirectionNotEqualThreshold,
    effectHasHigherProbabilityThanCausesThreshold,
    pchgRatioTooBigThreshold,
    pchgRatioTooSmallThreshold,
    isValidThreshold,
    isValidRatio,
    onChangeCauseImpactSignificanceThreshold,
    onChangeOptimalStateHasABadImpactAllNodePairsThreshold,
    onChangeOptimalStateHasABadImpactParentChildrenPairsThreshold,
    onChangeWchgAndPchgDirectionNotEqualThreshold,
    onChangeEffectHasHigherProbabilityThanCausesThreshold,
    onChangePchgRatioTooBigThreshold,
    onChangePchgRatioTooSmallThreshold
  } = t0;
  let t1;
  if ($[0] !== options) {
    t1 = IMPACT_DIRECTION_OPTIONS.every(key => options[key]);
    $[0] = options;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const areAllImpactDirectionsSelected = t1;
  let t2;
  if ($[2] !== options) {
    t2 = ASSUMPTION_SET_DEFINITION_OPTIONS.every(key_0 => options[key_0]);
    $[2] = options;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const areAllAssumptionSetDefinitionsSelected = t2;
  let t3;
  if ($[4] !== onChange || $[5] !== options) {
    t3 = (option, value) => {
      onChange({
        ...options,
        [option]: value
      });
    };
    $[4] = onChange;
    $[5] = options;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleWarningOptionChange = t3;
  let t4;
  if ($[7] !== onChange || $[8] !== options) {
    t4 = value_0 => {
      const updatedOptions = {
        ...options
      };
      IMPACT_DIRECTION_OPTIONS.forEach(key_1 => {
        updatedOptions[key_1] = value_0;
      });
      onChange(updatedOptions);
    };
    $[7] = onChange;
    $[8] = options;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleSelectAllImpactDirections = t4;
  let t5;
  if ($[10] !== onChange || $[11] !== options) {
    t5 = value_1 => {
      const updatedOptions_0 = {
        ...options
      };
      ASSUMPTION_SET_DEFINITION_OPTIONS.forEach(key_2 => {
        updatedOptions_0[key_2] = value_1;
      });
      onChange(updatedOptions_0);
    };
    $[10] = onChange;
    $[11] = options;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const handleSelectAllAssumptionSetDefinitions = t5;
  let t6;
  if ($[13] !== causeImpactSignificanceThreshold || $[14] !== effectHasHigherProbabilityThanCausesThreshold || $[15] !== handleWarningOptionChange || $[16] !== isValidThreshold || $[17] !== onChangeCauseImpactSignificanceThreshold || $[18] !== onChangeEffectHasHigherProbabilityThanCausesThreshold || $[19] !== options) {
    t6 = () => Object.entries(WARNING_LABELS).filter(_temp).map(t7 => {
      const [key_4, label] = t7;
      if (key_4 === "tooSmallImpactOfCauses") {
        const info = getWarningDescription(key_4);
        return <Box key={key_4} alignItems="center" display="flex" position="relative" width="100%"><Box alignItems="center" display="flex" flex="1" gap={2}><Checkbox checked={options[key_4 as keyof WarningOptions]} onCheckedChange={e => handleWarningOptionChange(key_4, !!e.checked)}><Box whiteSpace="nowrap">{label}</Box></Checkbox><Field.Root alignItems="center" display="flex" flexDirection="row" gap={1}><Field.Label fontSize="xs">(Threshold (%):</Field.Label><Input aria-label="Too small impact of causes threshold" ml={1} size="2xs" step="0.1" type="number" value={causeImpactSignificanceThreshold} width="60px" onChange={onChangeCauseImpactSignificanceThreshold} /><Field.Label fontSize="xs">)</Field.Label></Field.Root></Box>{info && <Box style={{
            width: "20px",
            height: "20px",
            position: "absolute",
            right: "-6px",
            top: "-8px"
          }}><InformationIcon contentWidth="380px" info={info} whiteSpace="pre-line" /></Box>}</Box>;
      }
      if (key_4 === "effectHasHigherProbabilityThanCauses") {
        return <WarningOptionWithThreshold key={key_4} ariaLabel="Effect has higher probability threshold" checked={options[key_4 as keyof WarningOptions]} info={getWarningDescription(key_4)} invalid={!isValidThreshold(effectHasHigherProbabilityThanCausesThreshold)} label={label} threshold={effectHasHigherProbabilityThanCausesThreshold} onCheckedChange={checked => handleWarningOptionChange(key_4, checked)} onThresholdChange={onChangeEffectHasHigherProbabilityThanCausesThreshold} />;
      }
      return <WarningOptionWithInfo key={key_4} handleWarningOptionChange={handleWarningOptionChange} info={getWarningDescription(key_4)} label={label} options={options} warningOptionKey={key_4 as keyof WarningOptions} />;
    });
    $[13] = causeImpactSignificanceThreshold;
    $[14] = effectHasHigherProbabilityThanCausesThreshold;
    $[15] = handleWarningOptionChange;
    $[16] = isValidThreshold;
    $[17] = onChangeCauseImpactSignificanceThreshold;
    $[18] = onChangeEffectHasHigherProbabilityThanCausesThreshold;
    $[19] = options;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  const renderMainOptions = t6;
  let t7;
  if ($[21] !== handleWarningOptionChange || $[22] !== options) {
    t7 = () => ASSUMPTION_SET_DEFINITION_OPTIONS.map(key_5 => <WarningOptionWithInfo key={key_5} handleWarningOptionChange={handleWarningOptionChange} info={getWarningDescription(key_5)} label={WARNING_LABELS[key_5]} options={options} warningOptionKey={key_5} />);
    $[21] = handleWarningOptionChange;
    $[22] = options;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  const renderAssumptionSetDefinitionOptions = t7;
  let t8;
  if ($[24] !== handleWarningOptionChange || $[25] !== isValidRatio || $[26] !== isValidThreshold || $[27] !== onChangeOptimalStateHasABadImpactAllNodePairsThreshold || $[28] !== onChangeOptimalStateHasABadImpactParentChildrenPairsThreshold || $[29] !== onChangePchgRatioTooBigThreshold || $[30] !== onChangePchgRatioTooSmallThreshold || $[31] !== onChangeWchgAndPchgDirectionNotEqualThreshold || $[32] !== optimalStateHasABadImpactAllNodePairsThreshold || $[33] !== optimalStateHasABadImpactParentChildrenPairsThreshold || $[34] !== options || $[35] !== pchgRatioTooBigThreshold || $[36] !== pchgRatioTooSmallThreshold || $[37] !== wchgAndPchgDirectionNotEqualThreshold) {
    t8 = () => IMPACT_DIRECTION_OPTIONS.map(key_6 => {
      const label_0 = WARNING_LABELS[key_6];
      const info_0 = getWarningDescription(key_6);
      if (key_6 === "optimalStateHasABadImpactAllNodePairs") {
        return <WarningOptionWithThreshold key={key_6} ariaLabel="Optimal state bad impact all node pairs threshold" checked={options[key_6]} info={info_0} invalid={!isValidThreshold(optimalStateHasABadImpactAllNodePairsThreshold)} label={label_0} threshold={optimalStateHasABadImpactAllNodePairsThreshold} onCheckedChange={checked_0 => handleWarningOptionChange(key_6, checked_0)} onThresholdChange={onChangeOptimalStateHasABadImpactAllNodePairsThreshold} />;
      }
      if (key_6 === "optimalStateHasABadImpactParentChildrenPairs") {
        return <WarningOptionWithThreshold key={key_6} ariaLabel="Optimal state bad impact parent children pairs threshold" checked={options[key_6]} info={info_0} invalid={!isValidThreshold(optimalStateHasABadImpactParentChildrenPairsThreshold)} label={label_0} threshold={optimalStateHasABadImpactParentChildrenPairsThreshold} onCheckedChange={checked_1 => handleWarningOptionChange(key_6, checked_1)} onThresholdChange={onChangeOptimalStateHasABadImpactParentChildrenPairsThreshold} />;
      }
      if (key_6 === "WCHGAndPCHGWarnings") {
        return <Box key={key_6} width="100%"><WarningOptionWithThreshold ariaLabel="WCHG and PCHG direction threshold" checked={options[key_6]} info={info_0} invalid={!isValidThreshold(wchgAndPchgDirectionNotEqualThreshold)} label={label_0} threshold={wchgAndPchgDirectionNotEqualThreshold} onCheckedChange={checked_2 => handleWarningOptionChange(key_6, checked_2)} onThresholdChange={onChangeWchgAndPchgDirectionNotEqualThreshold} /><VStack alignItems="start" gap={1} mt={1} pl={6}><Field.Root alignItems="center" display="flex" flexDirection="row" gap={1} invalid={!isValidRatio(pchgRatioTooBigThreshold)}><Field.Label fontSize="xs">PCHG/WCHG big:</Field.Label><Input _invalid={{
                borderColor: "red.500"
              }} aria-label="PCHG WCHG big threshold" ml={2} size="2xs" step="0.01" type="number" value={pchgRatioTooBigThreshold} width="60px" onChange={onChangePchgRatioTooBigThreshold} /><InformationIcon contentWidth="300px" info="Threshold: ratio considered TOO BIG (above)." /></Field.Root><Field.Root alignItems="center" display="flex" flexDirection="row" gap={1} invalid={!isValidRatio(pchgRatioTooSmallThreshold)}><Field.Label fontSize="xs">PCHG/WCHG small:</Field.Label><Input _invalid={{
                borderColor: "red.500"
              }} aria-label="PCHG WCHG small threshold" ml={2} size="2xs" step="0.01" type="number" value={pchgRatioTooSmallThreshold} width="60px" onChange={onChangePchgRatioTooSmallThreshold} /><InformationIcon contentWidth="300px" info="Threshold: ratio considered TOO SMALL (below)." /></Field.Root></VStack></Box>;
      }
      return <WarningOptionWithInfo key={key_6} handleWarningOptionChange={handleWarningOptionChange} info={info_0} label={label_0} options={options} warningOptionKey={key_6} />;
    });
    $[24] = handleWarningOptionChange;
    $[25] = isValidRatio;
    $[26] = isValidThreshold;
    $[27] = onChangeOptimalStateHasABadImpactAllNodePairsThreshold;
    $[28] = onChangeOptimalStateHasABadImpactParentChildrenPairsThreshold;
    $[29] = onChangePchgRatioTooBigThreshold;
    $[30] = onChangePchgRatioTooSmallThreshold;
    $[31] = onChangeWchgAndPchgDirectionNotEqualThreshold;
    $[32] = optimalStateHasABadImpactAllNodePairsThreshold;
    $[33] = optimalStateHasABadImpactParentChildrenPairsThreshold;
    $[34] = options;
    $[35] = pchgRatioTooBigThreshold;
    $[36] = pchgRatioTooSmallThreshold;
    $[37] = wchgAndPchgDirectionNotEqualThreshold;
    $[38] = t8;
  } else {
    t8 = $[38];
  }
  const renderImpactDirectionOptions = t8;
  let t9;
  if ($[39] !== renderMainOptions) {
    t9 = renderMainOptions();
    $[39] = renderMainOptions;
    $[40] = t9;
  } else {
    t9 = $[40];
  }
  let t10;
  if ($[41] !== handleSelectAllAssumptionSetDefinitions) {
    t10 = e_0 => handleSelectAllAssumptionSetDefinitions(!!e_0.checked);
    $[41] = handleSelectAllAssumptionSetDefinitions;
    $[42] = t10;
  } else {
    t10 = $[42];
  }
  let t11;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Box whiteSpace="nowrap">Requirement Definitions</Box>;
    $[43] = t11;
  } else {
    t11 = $[43];
  }
  let t12;
  if ($[44] !== areAllAssumptionSetDefinitionsSelected || $[45] !== t10) {
    t12 = <Checkbox checked={areAllAssumptionSetDefinitionsSelected} onCheckedChange={t10}>{t11}</Checkbox>;
    $[44] = areAllAssumptionSetDefinitionsSelected;
    $[45] = t10;
    $[46] = t12;
  } else {
    t12 = $[46];
  }
  let t13;
  if ($[47] !== renderAssumptionSetDefinitionOptions) {
    t13 = renderAssumptionSetDefinitionOptions();
    $[47] = renderAssumptionSetDefinitionOptions;
    $[48] = t13;
  } else {
    t13 = $[48];
  }
  let t14;
  if ($[49] !== t13) {
    t14 = <Box pl={4} width="100%"><VStack alignItems="start" width="100%">{t13}</VStack></Box>;
    $[49] = t13;
    $[50] = t14;
  } else {
    t14 = $[50];
  }
  let t15;
  if ($[51] !== handleSelectAllImpactDirections) {
    t15 = e_1 => handleSelectAllImpactDirections(!!e_1.checked);
    $[51] = handleSelectAllImpactDirections;
    $[52] = t15;
  } else {
    t15 = $[52];
  }
  let t16;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Box whiteSpace="nowrap">Impact Directions</Box>;
    $[53] = t16;
  } else {
    t16 = $[53];
  }
  let t17;
  if ($[54] !== areAllImpactDirectionsSelected || $[55] !== t15) {
    t17 = <Checkbox checked={areAllImpactDirectionsSelected} onCheckedChange={t15}>{t16}</Checkbox>;
    $[54] = areAllImpactDirectionsSelected;
    $[55] = t15;
    $[56] = t17;
  } else {
    t17 = $[56];
  }
  let t18;
  if ($[57] !== renderImpactDirectionOptions) {
    t18 = renderImpactDirectionOptions();
    $[57] = renderImpactDirectionOptions;
    $[58] = t18;
  } else {
    t18 = $[58];
  }
  let t19;
  if ($[59] !== t18) {
    t19 = <Box pl={4} width="100%"><VStack alignItems="start" width="100%">{t18}</VStack></Box>;
    $[59] = t18;
    $[60] = t19;
  } else {
    t19 = $[60];
  }
  let t20;
  if ($[61] !== t12 || $[62] !== t14 || $[63] !== t17 || $[64] !== t19 || $[65] !== t9) {
    t20 = <VStack alignItems="start" gap={2} pl={6} width="100%">{t9}{t12}{t14}{t17}{t19}</VStack>;
    $[61] = t12;
    $[62] = t14;
    $[63] = t17;
    $[64] = t19;
    $[65] = t9;
    $[66] = t20;
  } else {
    t20 = $[66];
  }
  return t20;
};
export default WarningOptionsDialog;
function _temp(t0) {
  const [key_3] = t0;
  return !IMPACT_DIRECTION_OPTIONS.includes(key_3 as keyof WarningOptions) && !ASSUMPTION_SET_DEFINITION_OPTIONS.includes(key_3 as keyof WarningOptions);
}